import { get, AHPLUS_API_URL } from "api/ky";

export const fetchLounges = async (airportCode) => {
  return await get(`${AHPLUS_API_URL}/api/v2/lounges/${airportCode}`);
};
